import { V4_COMPANY } from "../data/siteV4";

const Footer = () => (
  <footer className="bg-navy-900 text-white py-12 border-t border-white/10" data-testid="v4-footer">
    <div className="max-w-7xl mx-auto px-5 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <div className="flex items-center gap-4">
        <img src={V4_COMPANY.logoWhite} alt="Nikhan Controls" className="h-12 w-auto object-contain" />
        <div className="hidden md:block h-8 w-px bg-white/15" />
        <div className="hidden md:block text-[11px] uppercase tracking-[0.22em] text-slate-300 font-bold">
          {V4_COMPANY.tagline} · {V4_COMPANY.formerly}
        </div>
      </div>
      <div className="text-[11px] uppercase tracking-[0.22em] text-slate-400">
        © {new Date().getFullYear()} {V4_COMPANY.legal}
      </div>
    </div>
  </footer>
);
export default Footer;